import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ToolbarItemUploadDocument} from './toolbar-item-upload-document.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-toolbar-item-upload-gkk-document',
  templateUrl: './toolbar-item-upload-gkk-document.component.html',
  styles: [`
    ::ng-deep .ui-button-text {
      padding-left: 20px !important;
    }
  `]
})
export class ToolbarItemUploadGkkDocumentComponent extends ToolbarItemUploadDocument {

}
